export default __webpack_public_path__ + "static/media/ferocioussmack4.48017d15.png";